import { LanguageContext } from 'context/LanguageContext'
import React, { useContext } from 'react'

const PickupMsg = ({ className = '' }) => {
    const baseClass = 'pickup-msg'
    const fullClass = className ? `${baseClass} ${className}` : baseClass
    const { strings } = useContext(LanguageContext)


    return <div className={fullClass}>{strings.pickupOnly}</div>
}

export default PickupMsg
